import watchGetGroups from './getGroups';
import watchOpenEdit from './openEdit';

const watchGroups = [watchGetGroups, watchOpenEdit];

export default watchGroups;
